// import external dependencies
import "jquery";

// Require/Import vendors
require("../../../node_modules/flickity/dist/flickity.pkgd");
require("./vendor/flickity-fullscreen");
require("./vendor/jquery.txtTruncate");
// STELLAR USE
require("./vendor/isotope.pkgd");
// INTERSTELLAR USE
require("../../../node_modules/isotope-layout/dist/isotope.pkgd.js");

// Import everything from autoload
import "./autoload/_bootstrap.js";

// Import local dependencies/utils
import Router from "./util/Router";
import common from "./routes/common";
import home from "./routes/home";
import archive from "./routes/archive";

// Checkout API
import checkout from "./routes/checkout";
import account from "./routes/account";
import receipt from "./routes/receipt";
import aboutUs from "./routes/about";
import { sliders } from "./components/sliders";
import LazyLoad from "vanilla-lazyload";
import { liveHosts } from "./config";
import { getQuery } from "./util/dom";
require("./util/plusItem");
require("./util/crossPlatform");
require("./util/autoPadding");
require("./util/ellipsis");

// Require Components
require("./components/nav");
require("./components/filter");
require("./components/picker");
require("./components/resellers");
require("./components/video");
require("./components/instagram");
require("./components/newsletter");
require("./components/alert");
require("./components/category");
require("./components/section");
require("./components/checkoutv2");
require("./components/search");
require("./components/selected-modal");
require("./components/headroom");
require("./components/accordion");
require("./components/product");
require("./components/image-switcher");
require("./components/ze-widget");
require("./components/geo");
require("./components/copy");
require("./components/sticky-cart");
require("./components/system-filter");
require("./components/section-filter-anchor");
require("./components/system-filter-anchor");
require("./components/easycom");
require("./components/low-stock");
require("./components/form");
require("./components/thumbnail-filter");
require("./components/scroll");

// Interstellar
require("./components/interstellar/smorgasbord");
require("./components/interstellar/type-quote");
require("./components/interstellar/list-look");
require("./components/interstellar/dropdown");
require("./components/interstellar/video-grid");
require("./components/interstellar/story");

/** Populate Router instance with DOM routes */
var routes = new Router({
  // All pages
  common: common,
  // Home page
  home: home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs: aboutUs,
  archive: archive,
  // Checkout API
  checkout: checkout,
  account: account,
  templateThankyou: receipt
});

// Load Events
jQuery(document).ready(function () {
  routes.loadEvents();
  sliders.init();
  $(".js-plus-item").plusItem();
  $(".resellers-table").resellersTable();
  var lazyLoadInstance = new LazyLoad({
    elements_selector: ".lazy",
    threshold: 500,
    use_native: true,
    callback_enter: function callback_enter(el) {
      if (el.tagName === "IMG") return;
      if (el.dataset.bg && !el.dataset.bg.match("/((.*))/")) {
        el.dataset.bg = "url(".concat(window.sitewide.imagePlaceholder || "", ")");
      }
    },
    callback_error: function callback_error(el) {
      if (el.tagName !== "IMG") return;
      el.src = window.sitewide.imagePlaceholder || "";
      el.removeAttribute("data-srcset");
      el.removeAttribute("srcset");
    }
  });
  if (lazyLoadInstance) {
    lazyLoadInstance.update();
  }
  window.lazyLoadInstance = lazyLoadInstance;
  $("body").autoPadding({
    source: $(".js-header")
  });

  // WHEN THE LAST ITEM IN INTERSTELLAR MENU IS HIDDEN ON MOBILE
  // ADD CLASS TO THE 2ND TO THE LAST SO WE CAN REMOVE THE BORDER
  var navItems = document.querySelectorAll('nav.is-interstellar .navbar-nav-desktop .nav-item');
  if (navItems.length > 1 && navItems[navItems.length - 1].classList.contains('d-none')) {
    navItems[navItems.length - 2].classList.add('nav-item-last');
  }
});
$(window).on("load", function () {
  $("body").autoPadding({
    source: $(".js-header")
  });
  setTimeout(function () {
    $("body").addClass("page-loaded");
  }, 1000);
});

// Disable right click
document.addEventListener("contextmenu", function (e) {
  // Check if current page is an Interstellar page
  var isInterstellar = $("body").hasClass('is-interstellar') === true;

  // Check if the page is an Interstellar page and the current domain is the live site domain
  var isInterstellarProd = liveHosts.indexOf(window.location.hostname) > -1 && isInterstellar;

  // Get URL query parameters
  var queryParams = getQuery();

  // If on debug mode and in Interstellar page
  var debugRightClick = isInterstellar && queryParams.hasOwnProperty('disableRightClick');

  // Disable right click if debugRightClick is set or if the page is an Interstellar Prod page
  if (isInterstellarProd || debugRightClick) {
    e.preventDefault();
  }
}, false);


// WEBPACK FOOTER //
// ./scripts/main.js